/**
 * @title application-form.js: Feature level module
 * @description Membership application form functionality
 */
define(['membershipHelper','addressForm'], function(helper,addressForm) {
  let ApplicationForm = {
    /**
     * Initialize the module
     * @return {void}
     */
    init: function() {
      // Now rendering os part of the JSP.
      // this.createInline();
      helper.formWizBangs(this.getForm());
      this.promotionalHandlers();
      this.defaultAddressHandler();
    },
    
    defaultAddressHandler : function() {
		var $defaultAddressCheckbox = $('#set-default');
		var $defaultWarning = $('.defaultWarning.kb-OOS-banner');
		$defaultAddressCheckbox.change(function() {
			if ($defaultAddressCheckbox.is(':checked')) {
				$defaultWarning.show();
				$defaultAddressCheckbox.prop('value', true);
			} else if (!$defaultAddressCheckbox.is(':checked')) {
				$defaultWarning.hide();
				$defaultAddressCheckbox.prop('value', false);
			}
		});
	},
    /**
     * Determines the elements we need for which ever application we're
     * looking at.
     * @return {void}
     */
    createInline: function() {
      let elements = [];
      // Personal Information Template
      elements.push(['#primary-membership-block', 'tmpl_personal_info']);
      // Business Information Template
      if (helper.isBusinessMembership()) {
        elements.push(['#business-membership-block', 'tmpl_business_info']);
      }
      // Household Template
      elements.push(['#household-membership-block', 'tmpl_household_info']);
      // Preferences Template
      elements.push(['#checkboxes-membership-block', 'tmpl_checkboxes_membership']);
      for (let i = 0; i < elements.length; i++) {
        let placeholderId = elements[i][0];
        let templateId = elements[i][1];
        let html = ApplicationForm.createHtml(templateId);
        $(placeholderId).html(html);
      }
    },
    promotionalHandlers: function() {
      // Costco connection is hidden for goldstar basic; defaulted for this product number on backend
      // if (ApplicationStaticContent.productNumber == "35669") { $('.receivePromosAndMarketingCostcoConnection').hide() };
      let $promoCheckboxes = $('.viewModeElement');
      $promoCheckboxes.each(function(index, box) {
        $(box).change(function() {
          if ($(box).is(':checked')) {
            $(box).val('off');
          } else if (!$(box).is(':checked')) {
            $(box).val('on');
          }
        });
      });
      if (typeof wcs.locale != 'undefined' && wcs.locale == 'en_US') {
        $promoCheckboxes.each(function(index, box) {
          // $(box).removeAttr('checked').change();
          $(box).attr('checked', 'checked').change();
        });
      } else if (typeof wcs.locale != 'undefined' && (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA')) {
        $promoCheckboxes.each(function(index, box) {
          $(box).removeAttr('checked').change();
        });
      }
    },
    /**
     * [description]
     * @param  {[type]} template [description]
     * @param  {[type]} inputObj [description]
     * @param  {[type]} error    [description]
     * @return {[type]}          [description]
     */
    createHtml: function(template, inputObj, error) {
      template = $(COSTCO.util.tmpl(template, {}));
      if (template.find('.state-select').length) {
        let stateProvList = helper.getStateProvJson();
        let stateOptions = helper.getStateOptions(stateProvList);
        template.find('.state-select').append(stateOptions);
      }
      if (typeof(error) != 'undefined') {
        template.find('.error').html(error);
      }
      template.find('[name=postalcode]').on('input', function(event) {
        let value = $(event.currentTarget).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			helper.bingCityState(event.currentTarget, '[name=city]', '[name=state]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				helper.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				helper.geocodeApiCityState(event.currentTarget, '[name=city]', '[name=state]');
			}
		}
      });
      template.find('[name=businessZipCode]').on('input', function(event) {
        let value = $(event.currentTarget).val();
        let region = COSTCO.util.isUsOrCaZipCode();
		if($('#isGeocodeService').val() != "true" && value != null && value != "" && value.trim().length > 4){
			helper.bingCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
		}
		if($('#isGeocodeService').val() === "true" && value != null && value != "" && value.trim().length === value.length){
			if (region && COSTCO.util.POSTAL_CODE_REGEX_US.test(value.trim())) {
				helper.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
			}
			if (!region) {
				if ((value.trim().length === 3 && /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1}/.test(value.trim())) || (value.trim().length === 7 && COSTCO.util.POSTAL_CODE_REGEX_CA.test(value.trim())))
				helper.geocodeApiCityState(event.currentTarget, '[name=businessCity]', '[name=businessState]');
			}
		}
      });
      helper.dobPopulate(template, 100);
      helper.maskInput(template);
      return template;
    },
    /**
     * [description]
     * @return {[type]} [description]
     */
    validate: function() {
      // Override $.validate.methods to accommodate Mmeber Application context.
      helper.addValidationMethods(this.getForm());
      let rules = null;
      let messages = null;
      if (helper.isBusinessMembership()) {
        rules = helper.business.rules;
        messages = helper.business.messages();
      } else {
        rules = helper.goldstar.rules;
        messages = helper.goldstar.messages();
      }
      helper.addHouseholdRules(rules,undefined,messages);
      
      this.getForm().find('.style-select > select').each(function() {
			$(this).unbind('change').change(function(){
				if($(this).val()==="NO_STATE_TYPE_SELECTED"){
					selectsValid=false;
					$(this).parent().addClass('error');
				}else{
					$(this).parent().removeClass('error');
					if($(this).attr('hasvalidationerror') != undefined && $(this).attr('hasvalidationerror') != null){
						$(this).attr('hasvalidationerror', false);
					}
					var addressType = $('#addressType').val();
					if(addressType!='S'){
					const additionalBilllingStates = addressForm.getAdditionalBillingStates();
					addressForm.hideCheckboxForAdditionalTerritories($(this).val(), additionalBilllingStates);
					}
				}
			})
		});
	  this.getForm().find('.style-select > select').change();
      if (rules && messages) {
        this.getForm().validate({
          invalidHandler: COSTCO.util.invalid_handler,
          rules: rules,
          messages: messages,
        });
        return this.getForm().valid();
      } else {
        return false;
      }
    },
    /**
     * [description]
     * @return {[type]} [description]
     */
    getForm: function() {
      return $('#MemberAddressBookForm');
    },
    /**
     * [description]
     * @param  {[type]} addresses [description]
     * @return {jQuery.Deferred} Returns a deferred object that is chainable
     */
    submit: function(addresses) {
      let appForm = ApplicationForm;
      addresses = Array.isArray(addresses) // Test if we have valid addresses
        ? addresses // Using the addresses passed to "submit"
        : helper.buildAddressArray(this.getForm(), {
            primary: helper.personalAddressSelectors,
            business: helper.businessAddressSelectors,
          }); // using original addresse from user input
      helper.populateAddressData(this.getForm(), addresses);
      let formData = COSTCO.ApplicationForm.setDefaultDayValue(appForm.getForm().serializeArray());
      $('.order-ajax').addClass('ajax-busy');
      return COSTCO.util.ajax({
        type: 'POST',
        url: '/MemberApplicationAddCmd',
        dataType: 'json',
        global: false,
        data: formData,
        always: function() {
          $('.order-ajax').removeClass('ajax-busy');
        },
        complete: () => {}
      });
    },
    setDefaultDayValue: function(formData) {
    	const dayIsOptional = $('#dobYearMonthMandatoryFlag').val()==='true'
		if(dayIsOptional) {
	        return formData.map( formElement => {
	        	if((formElement.name == "day" || formElement.name == "household_day") && (formElement.value === "")) {
	        		formElement.value = "1";
	        	}
	        	return formElement;
	        })
		} else {
			return formData;
		}
    },    
    /**
     * Redirect to fromPage parameter or cart depending on if we didn't
     * get any errors.
     * @param  {Object} data The configProduct returned from the ajax call
     * @return {Object}      The configProduct for chaining.
     */
    redirect: function(data) {
      if (!data.error) {
    	  let fromCheckout = false;
    	  if(document.referrer.indexOf('Checkout') != -1) {
    		  fromCheckout = true;
    	  }
	      window.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
      } else {
    	  // Remove ajax-busy as the user stays on page and must be able to edit data
    	  $('.permanent-ajax-busy').removeClass('ajax-busy');
      }
      return data;
    },
    /**
     * [description]
     * @param  {[type]} addresses [description]
     * @return {[type]}           [description]
     */
    submitContinue: function(addresses) {
      return COSTCO.ApplicationForm.submit(addresses)
        // The call to /MemberApplicationAddCmd returns configProduct
        .then(helper.setConfigProduct)
        // If we have errors, display them.
        .then(helper.handleErrors)
        // If we're done, we're redirecting somewhere
        .then(COSTCO.ApplicationForm.redirect);
    },
    /**
     * [description]
     * @param  {[type]} addresses [description]
     * @return {[type]}           [description]
     */
    submitInvokeAddPersonModal: function(addresses) {
      return COSTCO.ApplicationForm.submit(addresses)
        // The call to /MemberApplicationAddCmd returns configProduct
        .then(helper.setConfigProduct)
        // If we have errors, display them.
        .then(helper.handleErrors)
        // Invoke the add person modal.
        .then(COSTCO.AffiliateForm.openAddPersonModal);
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.ApplicationForm = ApplicationForm;
  return ApplicationForm;
});



// WEBPACK FOOTER //
// ./js/membership/application-form.js